import { Dispatch, FC, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import HeartIconSVG from "../resources/svg/HeartIconSVG";
import useScreenSize from "../../custom-hooks/base-hooks/useScreenSize";
import BurgerMenuIconSVG from "../resources/svg/functional/BurgerMenuIconSVG";
import CustomBurgerMenu from "../../custom-components/CustomBurgerMenu";
import MobileHeaderBurgerMenuContents from "./burger-menu/MobileHeaderBurgerMenuContents";
import DesktopHeaderBurgerMenuContents from "./burger-menu/DesktopHeaderBurgerMenuContents";
import Logout from "./burger-menu/Logout";
import ProfileImage from "./ProfileImage";
import OneTimeWorkLogoSVG from "../resources/svg/logos/OneTimeWorkLogoSVG";
import NotificationsMenu from "./notifications/NotificationsMenu";

interface AuthHeaderVersionProps {
    setBackgroundBlur: Dispatch<SetStateAction<boolean>>;
    backgroundBlur: boolean;
}

const AuthHeader: FC<AuthHeaderVersionProps> = (props) => {
    const { upTo650, moreOrEqual650 } = useScreenSize();
    const { t } = useTranslation();
    const location = useLocation();

    const isMainPage = location.pathname === "/";
    const isCatalogPage = location.pathname === "/catalog";

    return (
        <header className="relative dmin2:h-[110px] td4:h-[80px] tmax4:h-[72px] dmin2:py-[30px] td4:py-[16px] tmax4:py-[12px] border-b border-b-backgroundButton">
            <div className="absolute flex justify-between items-center left-0 right-0 mx-auto dmin2:mx-auto di6:mx-[26px] ti6:mx-8 ti7:mx-5 tmax4:mx-[15px] dmin2:max-w-[1280px] di6:min-w-[960px] ti6:min-w-[725px] ti7:min-w-[600px]">
                <Link to="/">
                    <OneTimeWorkLogoSVG className="td4:w-[120px] tmax4:w-[100px]" />
                </Link>
                <div className="flex items-center">
                    <div className="tmax5:hidden mr-8 tmax3:mr-6">
                        <Link
                            to="/catalog"
                            className={`dmin2:H16B dmax2:H14B mr-6 transition duration-300 ${
                                isCatalogPage ? "text-textWhite" : "text-textFaded hover:text-textWhite"
                            }`}
                        >
                            {t("common.catalog")}
                        </Link>
                        <Link
                            to="/"
                            className={`dmin2:H16B dmax2:H14B mr-6 transition duration-300 ${
                                isMainPage ? "text-textWhite" : "text-textFaded hover:text-textWhite"
                            }`}
                        >
                            {t("common.main")}
                        </Link>
                    </div>
                    <Link
                        to="/create-work"
                        className="button tmax4:hidden dmin2:H16B dmax2:H14B dmin2:w-[275px] dmax2:w-[231px] dmin2:h-[50px] dmax2:h-[40px] transition duration-300"
                    >
                        <div className="mb-[2px]">{t("common.createOrder")}</div>
                    </Link>
                    <div className="flex items-center ml-8 tmax3:ml-6">
                        <Link to="/saved">
                            <HeartIconSVG className="tmax4:hidden mr-8 tmax4:mr-[30px] cursor-pointer dmax2:w-7 dmax2:h-7 text-textFaded hover:text-textWhite transition duration-300" />
                        </Link>
                        <NotificationsMenu
                            backgroundBlur={props.backgroundBlur}
                            setBackgroundBlur={props.setBackgroundBlur}
                        />
                        {upTo650 && (
                            <Link to="/profile" className="w-[41px] dmax2:w-8 h-[41px] dmax2:h-8 tmax4:mr-[30px]">
                                <ProfileImage />
                            </Link>
                        )}
                        <CustomBurgerMenu
                            backgroundBlur={props.backgroundBlur}
                            setBackgroundBlur={props.setBackgroundBlur}
                            popupClassName={`absolute z-[999] bg-backgroundInput right-0 border border-backgroundButton cursor-default h-fit rounded-b-[7px] py-5 px-6 ${
                                moreOrEqual650
                                    ? "td4:top-[55px] dmin2:top-[74px] w-[326px] dmax2:w-[275px]"
                                    : "tmax4:top-[44px] w-[275px]"
                            }`}
                            buttonElement={
                                upTo650 ? (
                                    <BurgerMenuIconSVG className="cursor-pointer text-textFaded hover:text-textWhite transition duration-300" />
                                ) : (
                                    <div className="w-[41px] dmax2:w-8 h-[41px] dmax2:h-8 tmax4:mr-[30px]">
                                        <ProfileImage />
                                    </div>
                                )
                            }
                        >
                            {moreOrEqual650 ? <DesktopHeaderBurgerMenuContents /> : <MobileHeaderBurgerMenuContents />}
                            <Logout />
                        </CustomBurgerMenu>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default AuthHeader;
